// extracted by mini-css-extract-plugin
export var csatScore = "_li-5";
export var header = "_li-1";
export var panelWrapper = "_li-2";
export var postPreview = "_li-3";
export var rightContent = "_li-0";
export var wrappingText = "_li-4";